import { h, FunctionComponent } from 'preact'
import styles from './progress.module.scss'

interface Props {
  left: number
  right: number
}

export const ProgressBars: FunctionComponent<Props> = ({
  left,
  right,
}: Props) => {
  const animBar = (side: string): number => {
    const variant = { left, right }
    return Math.round(280 - (variant[side] / 100) * 280)
  }

  return (
    <div className={styles.progressWrapper}>
      <div
        className={`
        ${left === 100 && styles.finished}
        ${left === 100 && right === 100 && styles.final}
        ${styles.leftProgressWrapper}
      `}
      >
        <div className={styles.progressLines}>
          <svg
            width="109"
            height="162"
            viewBox="0 0 131 196"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className={styles.top}
              style={{ strokeDashoffset: animBar('left') }}
              d="M 131 3.047 C 131 3.047 10.549 6.664 3.036 130.043 L 3.036 196"
            />
          </svg>
          <svg
            width="109"
            height="162"
            viewBox="0 0 131 196"
            className={styles.bottomWrapper}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className={styles.bottom}
              style={{ strokeDashoffset: animBar('left') }}
              d="M 131 3.047 C 131 3.047 10.549 6.664 3.036 130.043 L 3.036 196"
            />
          </svg>
        </div>
        <div className={styles.placeholder}>
          <svg
            width="109"
            height="324"
            viewBox="0 0 109 324"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity=".15"
              d="M106.5 322v0C48.032 319.334 2 271.156 2 212.627V111.373C2 52.844 48.032 4.666 106.5 2v0"
              stroke="#fff"
              strokeWidth="4"
              strokeLinecap="round"
            />
          </svg>
        </div>
      </div>
      <div
        className={`
        ${right === 100 && styles.finished}
        ${right === 100 && left === 100 && styles.final}
        ${styles.rightProgressWrapper}
      `}
      >
        <div className={styles.progressLines}>
          <svg
            width="109"
            height="162"
            viewBox="0 0 131 196"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className={styles.top}
              style={{ strokeDashoffset: animBar('right') }}
              d="M 131 3.047 C 131 3.047 10.549 6.664 3.036 130.043 L 3.036 196"
            />
          </svg>
          <svg
            width="109"
            height="162"
            className={styles.bottomWrapper}
            viewBox="0 0 131 196"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className={styles.bottom}
              style={{ strokeDashoffset: animBar('right') }}
              d="M 131 3.047 C 131 3.047 10.549 6.664 3.036 130.043 L 3.036 196"
            />
          </svg>
        </div>
        <div className={styles.placeholder}>
          <svg
            width="109"
            height="324"
            viewBox="0 0 109 324"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity=".15"
              d="M106.5 322v0C48.032 319.334 2 271.156 2 212.627V111.373C2 52.844 48.032 4.666 106.5 2v0"
              stroke="#fff"
              strokeWidth="4"
              strokeLinecap="round"
            />
          </svg>
        </div>
      </div>
    </div>
  )
}
